import axios from "axios";

// Use environment variable or fallback to empty string for relative URLs
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const getAuthHeader = () => {
  const token = localStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Alias for convenience
export const authHeaders = getAuthHeader;

export const formatDuration = (seconds) => {
  if (!seconds) return "00:00";
  const hours = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  if (hours > 0) return `${hours}h ${mins}m`;
  return `${mins}m`;
};

export const formatViews = (count) => {
  if (count >= 1000) return `${(count / 1000).toFixed(1)}K`;
  return count?.toString() || "0";
};

export const formatDateTime = (date, time) => {
  const d = new Date(`${date}T${time}`);
  return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) + ' at ' + 
         d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
};

export const formatTime12Hour = (timeStr) => {
  if (!timeStr) return "";
  const [hours, minutes] = timeStr.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
};
